import React from 'react';

const TermsPrint = () => (
  <div>
    <p>
      <strong>ABOUT PRINTCENTER</strong>
    </p>
    <p>Loyalty has its privileges.</p>
    <p>
      As a CLUBSKP member, you have access to PRINTCENTER, a user-friendly
      design tool that enables you to create customized print materials for your
      salon.
    </p>
    <p>
      We understand that building your salon business is important to you.
      PRINTCENTER empowers you to market your salon professionally. This is our
      offer to help you promote your business with professional material to
      build a stronger presence in your community.
    </p>
    <p>Take your client experience to the next level!</p>
    <p>
      <strong>HOW DOES IT WORK?</strong>
    </p>
    <p>
      <strong>STEP ONE: CHOOSE</strong>
    </p>
    <p>
      Choose from an assortment of thoughtfully designed artwork templates.The
      best part is new and updated templates will be added on an on-going basis.
    </p>
    <p>
      <strong>STEP TWO: CUSTOMIZE</strong>
    </p>
    <p>
      Insert your salon logo, and business details. Whether you’re planning an
      event or planning a promotion, the design portal includes clear and
      concise visual indicators that tell you what information is required to
      complete the artwork.
    </p>
    <p>
      <strong>STEP THREE: REVIEW</strong>
    </p>
    <p>Review the final artwork and check for errors. Make sure you love it.</p>
    <p>
      <strong>STEP FOUR: SAVE & PRINT</strong>
    </p>
    <p>
      If you love it, let’s go to print. You have two options: 1 - print with
      our preferred third-party vendor, Zapplogix Inc., or 2 - download the
      artwork, and then take it to your local printing house to arrange
      printing.
    </p>
    <p>
      <strong>STEP FIVE: ADVERTISE!</strong>
    </p>
    <p>
      Use the printed artwork to advertise your business! Your use of the
      artwork must be in accordance with the MYSKP Terms of Use, including any
      time periods in which a particular artwork template may be used.
    </p>
    <p>
      <strong>WHY USE PRINTCENTER</strong>
    </p>
    <p>
      We recognize that not everyone can have a superstar marketing team to
      support their business.
    </p>
    <p>
      <strong>It’s Convenient:</strong> PRINTCENTER provides your salon with
      professional quality & easily customizable marketing materials at the
      touch of a button, wherever you are.
    </p>
    <p>
      <strong>Help Boost your Business:</strong> PRINTCENTER enables your salon
      to promote your business and engage your clients - gain more exposure, and
      help build customer loyalty.
    </p>
    <p>
      <strong>Personalization:</strong> It’s your logo, your content, your way.
    </p>
    <p>
      <strong>FAQ</strong>
    </p>
    <ol style={{ paddingLeft: '16px' }}>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>
            Do I have to be a CLUBSKP member to access the PRINTCENTER?
          </strong>
        </p>
        <p>a. Only salons registered on CLUBSKP have access to PRINTCENTER.</p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>
            What types of marketing materials are available on PRINTCENTER?
          </strong>
        </p>
        <p>
          a. Salons can customize loyalty cards, posters, event flyers, and
          more! The database is growing, there will always be more to explore.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Who is the preferred printing vendor?</strong>
        </p>
        <p>a. Zapplogix Inc.</p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Do I have to print with the suggested vendor?</strong>
        </p>
        <p>
          a. No. Once you’ve completed your artwork to your satisfaction, you
          can download the artwork and take it to a local printer.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>How long will it take to receive my order?</strong>
        </p>
        <p>
          a. If you choose to use Zapplogix Inc, their delivery time is
          approximately 7-10 business days.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>
            Do the materials I create on PRINTCENTER qualify for Co-op
            Advertising?
          </strong>
        </p>
        <p>
          a. No. To find out more about co-op advertising, talk to your local
          Technical Advisor.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Do I have to order a minimum quantity?</strong>
        </p>
        <p>
          a. Some materials are more cost efficient with a minimum order. If you
          have a small batch, we suggest downloading the artwork and taking it
          to your local printer.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Can I cancel or change my order?</strong>
        </p>
        <p>
          a. If you have chosen to print with Zapplogix Inc. and have placed
          your order, it cannot be altered or cancelled.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>
            I notice the Schwarzkopf Professional logo on all the artwork, can I
            remove it?
          </strong>
        </p>
        <p>a. No.</p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>I don’t see anything I want to create on PRINTCENTER.</strong>
        </p>
        <p>
          a. We are open to suggestions! This tool was made for you. With your
          feedback, we can create and upload templates that satisfy your needs.
          Send us your feedback.
        </p>
      </li>
    </ol>
  </div>
);

export default TermsPrint;



// WEBPACK FOOTER //
// ./src/components/_Site/CA/TermsPrint.js